/**
 * 환경별 로그 관리 유틸리티
 * - development: 모든 로그 출력
 * - production: 로그 비활성화
 */

const isDevelopment = process.env.NODE_ENV === 'development'

const logger = {
	log: (...args: any[]) => {
		if (isDevelopment) {
			console.log(...args)
		}
	},
	info: (...args: any[]) => {
		if (isDevelopment) {
			console.info(...args)
		}
	},
	warn: (...args: any[]) => {
		if (isDevelopment) {
			console.warn(...args)
		}
	},
	error: (...args: any[]) => {
		// 에러는 운영에서도 출력 (필요시 false로 변경)
		if (isDevelopment) {
			console.error(...args)
		}
	},
	debug: (...args: any[]) => {
		if (isDevelopment) {
			console.debug(...args)
		}
	},
	table: (...args: any[]) => {
		if (isDevelopment) {
			console.table(...args)
		}
	},
}

/**
 * 운영 환경에서 console 전체 비활성화
 * index.tsx에서 호출
 */
export const disableConsoleInProduction = () => {
	if (process.env.NODE_ENV === 'production') {
		console.log = () => {}
		console.info = () => {}
		console.warn = () => {}
		console.debug = () => {}
		console.table = () => {}
		// console.error는 운영에서도 유지 (에러 추적용)
		// 필요시 아래 주석 해제하여 비활성화
		// console.error = () => {}
	}
}

export default logger
